/**
 * 功能: 段落组件, 显示报告里section和attachment
 */
<template lang="pug">
  div(style="font-size:14px;")
    div(v-for="(child, index) in data.sections" style='margin:20px 0;')
      span.preview-content-text(v-html="formatText(child.text)" v-if="child && !child.status" style="text-indent:2em;")
      template(v-for="(item, index) in child.attachment")
        showAttachment(:attachmentInfo="item" style='width:100%;margin:0 auto;')
</template>

<script>
import showAttachment from './showAttchment'
const MarkdownIt = require('markdown-it')
const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true
})
export default {
  name: 'Section',
  components: {
    showAttachment
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    formatText (text) {
      if (typeof text === 'string') {
        return md.render(text)
      }
    }
  }
}
</script>

<style>
.preview-content-text p{
  font-size: 14px;
}
</style>
